import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Componente wrapper per React.StrictMode
const AppWithStrictMode = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<AppWithStrictMode />);

// Registrazione del service worker per PWA
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('PWA installata e pronta per l\'uso offline!');
  },
  onUpdate: (registration) => {
    console.log('Nuova versione disponibile!');
    // Mostra notifica di aggiornamento se supportata
    serviceWorkerRegistration.showUpdateAvailableNotification();
    
    // Opzionale: aggiorna automaticamente dopo un delay
    setTimeout(() => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        window.location.reload();
      }
    }, 5000);
  }
});

// Richiedi permessi per le notifiche
serviceWorkerRegistration.requestNotificationPermission();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
